import { get, post } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';
import { publishAuthSessionChanged } from '@nbx/frontend-helpers/publish';

let baseUrl = 'auth';

// prettier-ignore
const NBXAuth = {
  init: config => ({ baseUrl } = config),

  verify: (token, code, useRecoveryCode, isPolling = false) => {
    const json = useRecoveryCode ? {
      token,
      recovery_code: code,
      is_polling: isPolling,
    }  : {
      token,
      code,
      is_polling: isPolling,
    };
    const headers = {'x-nbx-mobile-app': `${window.PLATFORM !== 'web'}` };
    return post(`${baseUrl}/verify`, {
      json,
      headers
    })
    .then(session => {
      if (
        session.constructor !== Object
        || Object.entries(session).length === 0
        || session.token === undefined
        || session.userId === undefined
        || session.accountId === undefined
      ) throw 'no_session_found';

      // In mobile app, we generate a Device Token instead of a Session Token
      if (window.PLATFORM === 'web') {
        publishAuthSessionChanged(session);
      }
      return session;
    });
  },
  
  verifyDevice: (token) => {
    return post(`${baseUrl}/verify/device`, {
      json: {token},
      // headers: {'x-nbx-override-expire': '600'}
    })
    .then(session => {
      if (
        session.constructor !== Object
        || Object.entries(session).length === 0
        || session.token === undefined
        || session.userId === undefined
        || session.accountId === undefined
      ) throw 'no_session_found';
      publishAuthSessionChanged(session);
      return session;
    });
  },

  getAccounts: () => context.session().then(session => get(`${baseUrl}/users/${session.userId}/accounts`, session)),
  oAuthAccounts: async (firebaseToken, orgID) => {
    let uriParams = `firebase_token=${firebaseToken}`;
    if (orgID) {
      uriParams += `&org_id=${orgID}`;

    }
    const response = await fetch(`${baseUrl}/oauth2/accounts?${uriParams}`);
    return response.json();
  }

};

export default NBXAuth;
